import { render, staticRenderFns } from "./user-menu.vue?vue&type=template&id=53eeebb2&scoped=true&"
import script from "./user-menu.vue?vue&type=script&lang=ts&"
export * from "./user-menu.vue?vue&type=script&lang=ts&"
import style0 from "./user-menu.vue?vue&type=style&index=0&id=53eeebb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eeebb2",
  null
  
)

export default component.exports